<template>
    <div class="container">
        <div class="logo-top-block">
            <img class="logo" src="/img/logo.svg" alt="" />
            <img src="/img/fridge.svg" alt="" />
        </div>
        <div class="content-block">
            <div class="white-bg-block h585">
                <div class="center-position-div closed-page-1">
                    <img src="/img/lock.svg" alt="" />
                    <span class="fs36 bold">Извините, <br />холодильник закрыт</span>
                    <span class="fs20">Откроется в 14:00</span>
                </div>
            </div>
        </div>
        <div class="pay-systems">
            <ul>
                <li><img src="/img/pay_systems/Visa.svg" alt=""/></li>
                <li><img src="/img/pay_systems/MasterCard.svg" alt=""/></li>
                <li><img src="/img/pay_systems/Mir.svg" alt=""/></li>
                <!--<li><img src="/img/pay_systems/ApplePay.svg" alt=""/></li>
                <li><img src="/img/pay_systems/GooglePay.svg" alt=""/></li>-->
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Closed',
        data() {
            return {

            };
        },
        created() {
        },
        mounted() {
        },
        methods: {
        },
    };
</script>

<style>
</style>
